import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { logError } from 'utils/logger';
import { getEmployeeProjectView } from '../../service';

export function useEmployeeProjectView(employeeId, projectId) {
  const [projectData, setProjectData] = useState(null);
  const [loading, setLoading] = useState(Boolean(employeeId && projectId));

  const fetchProjectData = useCallback(async () => {
    setLoading(true);
    try {
      const data = await getEmployeeProjectView(employeeId, projectId);
      setProjectData(data);
    } catch (error) {
      toast.error(
        logError({
          message: 'Failed to fetch project details',
          error: error,
          code: 'EMPLOYEE_PROJECT_VIEW_FETCH_FAILED',
        }),
      );
    } finally {
      setLoading(false);
    }
  }, [employeeId, projectId]);

  useEffect(() => {
    if (employeeId && projectId) {
      fetchProjectData();
    }
  }, [employeeId, projectId, fetchProjectData]);

  return { projectData, loading, refresh: fetchProjectData };
}
